export const DESKTOP_MIN_WIDTH = 960

export function media(minWidth) {
    return `@media (min-width: ${minWidth}px)`
}